export default {"src":"/_next/static/media/mask-banner-home.738ce7be.svg","height":87,"width":1920};